import { SetGenderMode as DLSetGenderMode, GetUserZone as DLGetUserZone, SaveUserZone as DLSaveUserZone, SubmitResponse as DLSubmitResponse, SendQuestionToUsers as DLSendQuestionToUsers, GetAllResults as DLGetAllResults, GetResultsByQuestion as DLGetResultsByQuestion, ResetAllResults as DLResetAllResults, SendResultsToScreen as DLSendResultsToScreen, GetColors as DLGetColors, SetColor as DLSetColor, ResetCurrentDynamic as DLResetCurrentDynamic, StartLottery as DLStartLottery, SendNextCard as DLSendNextCard, GetAllLotteryResults as DLGetAllLotteryResults, GetAllLotteryResultsByCard as DLGetAllLotteryResultsByCard, ValidateResponse as DLValidateResponse, GetGenderMode as DLGetGenderMode, StartBallonsGame as DLStartBallonsGame, RestartBallonsGame as DLRestartBallonsGame, GetBalloonState as DLGetBalloonState, GetBalloonStats as DLGetBalloonStats, SendBalloonsTap as DLSendBalloonsTap, GetAllRiddleResults as DLGetAllRiddleResults, SendRiddleResultsToScreen as DLSendRiddleResultsToScreen, SendRiddleQuestionToUsers as DLSendRiddleQuestionToUsers, ShowItemOnScreen as DLShowItemOnScreen, SubmitRiddleResponse as DLSubmitRiddleResponse, GetAutozoneState as DLGetAutozoneState, SetAutozoneState as DLSetAutozoneState, GetAllQuizzWithImageAndOptionsResults as DLGetAllQuizzWithImageAndOptionsResults, SendQuizzWithImageAndOptionsResultsToScreen as DLSendQuizzWithImageAndOptionsResultsToScreen, SendQuizzWithImageAndOptionsQuestionToUsers as DLSendQuizzWithImageAndOptionsQuestionToUsers, SubmitQuizzWithImageAndOptionsResponse as DLSubmitQuizzWithImageAndOptionsResponse } from './../DL/Zones' //ValidateUserZone as DLValidateUserZone


const phase = {
  WAITING: "WAITING",
  RUNNING: "RUNNING",
  FINISHED: "FINISHED",
}


const GetGenderMode = async () => {
    try {
        const response = await DLGetGenderMode()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar cargar la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

const SetGenderMode = async (activeWomensMode) => {
  try {
    const response = await DLSetGenderMode(activeWomensMode)
        
    if (response.success) {
        return { success: true, data: response.data }
    } else {
        return { success: false, message: response.message }
    }
  } catch (error) {
    return { success: false, message: 'Lo sentimos. Hubo un error al intentar cambiar el modo de la aplicación. Intenta actualizar la página o inténtalo más tarde.' }
  }
}

/**
 * Función que obtiene la información de la zona (del estadio) que tiene el usuario
 * @returns 
 */
const GetUserZone = async () => {
    try {
        const response = await DLGetUserZone()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Lo sentimos. Hubo un error al intentar obtener la información. Intenta actualizar la página o inténtalo más tarde.' }
    }
}

/**
 * Función que valida si el texto que recibe es una zona válida
 * @param {string} zone 
 * @returns 
 */
const ValidateZone = async (_zone) => {
  try {
    if (!_zone || typeof _zone !== 'string') {
      return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida' }
    }

    const zone = _zone.trim().toLowerCase()

    // Validar letras minúsculas Unicode, números y espacios
    const regex = /^[\p{Ll}\p{Nd} ]+$/u
    if (!regex.test(zone)) {
        return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida' }
    }
    
    let zoneData = {
      id: null,
      name: null,
      text: null
    }
    
    switch (zone) {
        // Agnostic Dorados - Zona 1 (Eldo Local)
        case "zona1":
        case "zona 1":
        case "eldo local":
        case "eldo1":
        case "eldo 1":
        case "team eldo local":
        case "lucho":
        case "team lucho":
          zoneData.id = 1
          zoneData.name = 'Team Eldo Local'
          zoneData.text = 'zona1'
          break

        // Agnostic Dorados - Zona 2 (Eldo Visitante)
        case "zona2":
        case "zona 2":
        case "eldo visitante":
        case "eldo2":
        case "eldo 2":
        case "team eldo visitante":
        case "tunita":
        case "team tunita":
          zoneData.id = 2
          zoneData.name = 'Team Eldo Visitante'
          zoneData.text = 'zona2'
          break

        // Normales
        case "laboratorio tequis":
          zoneData.id = 1
          zoneData.name = 'Zona Laboratorio Tequis'
          zoneData.text = 'laboratorio tequis'
          break

        case "san luis":
          zoneData.id = 2
          zoneData.name = 'Zona San Luis'
          zoneData.text = 'san luis'
          break
    
        case "seguros el potosí":
        case "seguros el potosi":
          zoneData.id = 3
          zoneData.name = 'Zona Seguros El Potosí'
          zoneData.text = 'seguros el potosí'
          break

        case "red cola":
          zoneData.id = 4
          zoneData.name = 'Zona Red Cola'
          zoneData.text = 'red cola'
          break

        case "corona":
          zoneData.id = 5
          zoneData.name = 'Zona Corona'
          zoneData.text = 'corona'
          break

        case "moctezuma":
          zoneData.id = 6
          zoneData.name = 'Zona Moctezuma'
          zoneData.text = 'moctezuma'
          break

        case "atleti":
          zoneData.id = 7
          zoneData.name = 'Zona Atleti'
          zoneData.text = 'atleti'
          break

        case "mobil":
          zoneData.id = 8
          zoneData.name = 'Zona Mobil'
          zoneData.text = 'mobil'
          break

        case "azul":
          zoneData.id = 9
          zoneData.name = 'Zona Azul'
          zoneData.text = 'azul'
          break

        case "oro":
          zoneData.id = 10
          zoneData.name = 'Zona Oro'
          zoneData.text = 'oro'
          break

        case "palcos":
          zoneData.id = 11
          zoneData.name = 'Zona Palcos'
          zoneData.text = 'palcos'
          break

        default:
          zoneData = null
          break
    }

    if (zoneData) {
      return { success: true, data: zoneData }
    } else {
      return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida' }
    }
  } catch (error) {
    return { success: false, message: 'No ha sido posible validar la zona' }
  }
}

/**
 * Función que valida si el id que recibe es una zona válida
 * @param {string|number} numberZone
 * @returns 
 */
const ValidateNumberZone = async (numberZone) => {
  try {
    const parsedId = parseInt(numberZone, 10)
    if (isNaN(parsedId)) {
        return { success: false, message: null }
    }
    
    const zoneData = {
      text: null
    }

    switch (parsedId) {
        // Agnostic Dorados
        case 1:
        case 9:
          zoneData.text = 'zona1'
          break

        case 2:
        case 10:
          zoneData.text = 'zona2'
          break

        case 3:
          zoneData.text = 'seguros el potosí'
          break

        case 4:
          zoneData.text = 'red cola'
          break

        case 5:
          zoneData.text = 'corona'
          break

        case 6:
          zoneData.text = 'moctezuma'
          break

        case 7:
          zoneData.text = 'atleti'
          break

        case 8:
          zoneData.text = 'mobil'
          break

        case 11:
          zoneData.text = 'palcos'
          break

        default:
          zoneData = null
          break
    }
    
    if (zoneData) {
      return { success: true, data: zoneData }
    } else {
      return { success: false, message: 'Lo sentimos. La zona que elegiste no es válida' }
    }
  } catch (error) {
    return { success: false, message: 'No ha sido posible validar la zona' }
  }
}

/**
 * Función que guarda la zona (del estadio) que eligió el usuario o que le fue asignada
 * @param {object} zone
 * @returns 
 */
const SaveUserZone = async (zone) => {
  try {
    // Valida que sea una zona válida y obtiene la información de esta
    const responseValidate = await ValidateZone(zone)
    
    if (responseValidate.success) {
      // Crear objeto con info de la zona
      const zoneData = {
        id: responseValidate.data.id,
        name: responseValidate.data.name,
        text: responseValidate.data.text
      }
      
      const response = await DLSaveUserZone(zoneData)
      
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.message }
      }
    } else {
      return { success: false, message: responseValidate.message }    
    }
  } catch (error) {
      return { success: false, message: 'Lo sentimos. Hubo un error al intentar guardar tu zona. Inténtalo nuevamente o inténtalo más tarde.' }
  }
}










// ---------- Websockets ----------//

let socket = null
let isConnected = false
let reconnectTimeout = null
let reconnectAttempts = 0
const MAX_RECONNECT_ATTEMPTS = 10

// NEW: buffer de mensajes para evitar perder snapshots si el handler aún no está listo
let pendingMessages = []
// guardamos un handler actual (si existe)
let currentMessageHandler = null

const IsWebSocketReady = () => {
  return socket && isConnected && socket.readyState === WebSocket.OPEN
}

// Limpia todo el estado de WS (con buffer)
const _resetWsState = () => {
  if (socket) {
    socket.onopen = null
    socket.onclose = null
    socket.onerror = null
    socket.onmessage = null
    socket.onCustomMessage = null
    try { socket.close() } catch {}
  }
  socket = null
  isConnected = false
  clearTimeout(reconnectTimeout)
  reconnectAttempts = 0
  // opcional: NO limpies pendingMessages aquí para no perder mensajes tardíos del servidor.
  // Si prefieres, puedes vaciarlo aquí también.
}

const DisconnectWebSocket = () => {
  try { _resetWsState() } catch {}
}

const WaitUntilConnected = (timeout = 5000) => {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    const check = () => {
      if (IsWebSocketReady()) resolve(true)
      else if (Date.now() - start > timeout) reject(new Error('El WebSocket no se conectó a tiempo'))
      else setTimeout(check, 100)
    }
    check()
  })
}

const _installOnMessage = () => {
  socket.onmessage = (event) => {
    try {
      const payload = JSON.parse(event.data)

      // Lógica especial: assignedZone (se mantiene)
      if (payload.type === 'assignedZone') {
        const rawData = sessionStorage.getItem(process.env.REACT_APP_SESSION)
        const session = rawData ? JSON.parse(rawData) : {}
        session.navigation = session.navigation || {}
        session.navigation.zone = { id: null, text: payload.data.zone }
        sessionStorage.setItem(process.env.REACT_APP_SESSION, JSON.stringify(session))
      }

      // NEW: siempre encolamos primero (por si no hay handler aún)
      pendingMessages.push(payload)

      // Si ya hay handler registrado, drenamos en orden
      if (typeof currentMessageHandler === 'function') {
        const queue = pendingMessages
        pendingMessages = []
        for (const msg of queue) {
          try { currentMessageHandler(msg) } catch (e) { console.error('[WS] handler error:', e) }
        }
      }
    } catch (err) {
      console.error('[WebSocket] ❌ Error al procesar mensaje:', err)
    }
  }
}

const ConnectWebSocket = async (zoneName, onStatusChange = () => {}, onToast = () => {}) => {
  if (socket || isConnected) return

  const connect = () => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      onStatusChange('error')
      console.warn('[WebSocket] 🚫 Límite de reconexiones alcanzado')
      return
    }

    reconnectAttempts++
    socket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?zona=${zoneName}`)
    onStatusChange('connecting')

    socket.onopen = () => {
      isConnected = true
      reconnectAttempts = 0
      onStatusChange('connected')
      onToast('Conectado')
    }

    socket.onclose = () => {
      isConnected = false
      socket = null
      onStatusChange('reconnecting')
      reconnectTimeout = setTimeout(connect, 3000)
    }

    socket.onerror = (e) => {
      console.error('[WebSocket] ❌ Error de conexión:', e)
      onStatusChange('error')
    }

    // NEW: instala onmessage con buffer
    _installOnMessage()
  }

  connect()
}

const SetSocketMessageHandler = (onMessage) => {
  currentMessageHandler = typeof onMessage === 'function' ? onMessage : null

  if (!socket) {
    // no hay socket aún: cuando se conecte, igual usaremos el buffer
    return
  }

  // Si ya está conectado, simplemente drenamos lo que haya pendiente
  if (typeof currentMessageHandler === 'function' && pendingMessages.length > 0) {
    const queue = pendingMessages
    pendingMessages = []
    for (const msg of queue) {
      try { currentMessageHandler(msg) } catch (e) { console.error('[WS] handler error:', e) }
    }
  }
}

const ClearSocketMessageHandler = () => {
  currentMessageHandler = null
}

//
// ---------- Websockets SCREEN (pantalla) ----------//
// Reutilizamos el mismo buffer/handler global para pantalla
//
const ConnectWebSocketForScreen = async (onStatusChange = () => {}, onToast = () => {}) => {
  if (socket || isConnected) return

  const connect = () => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      onStatusChange('error')
      console.warn('[WebSocket] 🚫 Límite de reconexiones alcanzado')
      return
    }

    reconnectAttempts++
    // 👇 ¡ojo con el nombre del parámetro!
    //const uid = 'screen-1'; // cualquier id estable para reconexiones
    //socket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=pantalla&uid=${uid}`)
    socket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=pantalla`)
    onStatusChange('connecting')

    socket.onopen = () => {
      isConnected = true
      reconnectAttempts = 0
      onStatusChange('connected')
      onToast('¡Pantalla conectada!')
    }

    socket.onclose = () => {
      isConnected = false
      socket = null
      onStatusChange('reconnecting')
      reconnectTimeout = setTimeout(connect, 3000)
    }

    socket.onerror = (e) => {
      console.error('[WebSocket] ❌ Error de conexión pantalla:', e)
      onStatusChange('error')
    }

    // NEW: instala onmessage con buffer (pantalla también)
    _installOnMessage()
  }

  connect()
}

//
// ---------- Websockets SÚPER LIENZO V2 (pantalla) ----------//
// Nueva conexión independiente para la arquitectura de Broadcast
//
const ConnectWebSocketForScreenV2 = async (screenId, onStatusChange = () => {}, onToast = () => {}) => {
  if (socket || isConnected) return

  const connect = () => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      onStatusChange('error')
      console.warn('[WebSocket] 🚫 Límite de reconexiones alcanzado para Screen V2')
      return
    }

    reconnectAttempts++
    
    // 👇 AQUÍ ESTÁ LA MAGIA: Nos conectamos con el nuevo tipo para la V2 y un ID único
    const uid = `screen-v2-${screenId}`; // Idempotencia para reconexiones
    socket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=pantalla-v2:${screenId}&uid=${uid}`)
    
    onStatusChange('connecting')

    socket.onopen = () => {
      isConnected = true
      reconnectAttempts = 0
      onStatusChange('connected')
      onToast(`¡Lienzo V2 (${screenId}) Conectado!`)
    }

    socket.onclose = () => {
      isConnected = false
      socket = null
      onStatusChange('reconnecting')
      reconnectTimeout = setTimeout(connect, 3000)
    }

    socket.onerror = (e) => {
      console.error('[WebSocket] ❌ Error de conexión Lienzo V2:', e)
      onStatusChange('error')
    }

    // Usamos el mismo buffer de mensajes que ya tienes implementado
    _installOnMessage()
  }

  connect()
}

// ---------- Websockets ----------//



//---------- SCREEN ----------//

const SubmitResponse = async (questionId) => {
  try {
    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const zone = responseZone?.data?.text
      
      if (zone) {
        const response = await DLSubmitResponse(questionId, zone)
        
        if (response.success) {
          return { success: true, data: response.data }
        } else {
          return { success: false, message: response.message }
        }
      }
    } else {

    }
  } catch (error) {
    
  }
}

//---------- SCREEN ----------//

//---------- QUIZ ADMIN ----------//

const SendQuestionToUsers = async (question) => {
  try {
    const response = await DLSendQuestionToUsers(question)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetAllResults = async () => {
  try {
    const response = await DLGetAllResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetResultsByQuestion = async (question) => {
  try {
    const idQuestion = question?.id
    if (!idQuestion) {
      return { success: false, message: 'No ha sido posible obtener los resultados. Inténtalo nuevamente o inténtalo más tarde.' }
    }

    const response = await DLGetResultsByQuestion(idQuestion)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const ResetAllResults = async () => {
  try {
    const response = await DLResetAllResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendResultsToScreen = async () => {
  try {
    const response = await DLSendResultsToScreen()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- QUIZ ADMIN ----------//

//---------- COLORS ADMIN ----------//

const GetColors = async () => {
  try {
    const response = await DLGetColors()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SetColor = async (idTheme) => {
  try {
    const response = await DLSetColor(idTheme)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const ResetCurrentDynamic = async () => {
  try {
    const response = await DLResetCurrentDynamic()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- COLORS ADMIN ----------//

//---------- LOTTERY ADMIN ----------//

const StartLottery = async (boardSize, view) => {
  try {
    const response = await DLStartLottery(boardSize, view)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendNextCard = async (card, view) => {
  try {
    const response = await DLSendNextCard(card, view)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetAllLotteryResults = async () => {
  try {
    const response = await DLGetAllLotteryResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const GetAllLotteryResultsByCard = async () => {
  try {
    const response = await DLGetAllLotteryResultsByCard()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- LOTTERY ADMIN ----------//

//---------- BALLONS ADMIN ----------//

// Mapea el status del backend a las fases del admin
const MapStatusToPhase = (status) => {
  switch (status) {
    case 0: // BalloonMatchStatus.Waiting
    case "Waiting":
      return phase.WAITING
    case 1: // Running
    case "Running":
      return phase.RUNNING
    case 2: // Finished
    case "Finished":
      return phase.FINISHED
    default:
      return phase.WAITING
  }
}

const StartBallonsGame = async (points, time, countdown = 3, sendBatchThreshold = 10, sendBatchTimeoutMs = 0) => {
  try {
    // const target = Number(points) || 120
    // const duration = Number(time) || 30
    // const cd = Number(countdown) || 3

    // if (target < 1) return { success: false, message: "La meta de puntos debe ser >= 1" }
    // if (duration < 5) return { success: false, message: "La duración debe ser >= 5s" }
    // if (cd < 1) return { success: false, message: "El countdown debe ser >= 1s" }

    const target   = Number(points)            || 120
    const duration = Number(time)              || 30
    const cd       = Number(countdown)         || 3
    const th       = Number(sendBatchThreshold) || 10
    const toMs     = Number(sendBatchTimeoutMs) || 0

    if (target   < 1) return { success: false, message: "La meta de puntos debe ser >= 1" }
    if (duration < 5) return { success: false, message: "La duración debe ser >= 5s" }
    if (cd       < 1) return { success: false, message: "El countdown debe ser >= 1s" }
    if (th       < 1) return { success: false, message: "El umbral de envío debe ser >= 1" }
    if (toMs     < 0) return { success: false, message: "El timeout de envío no puede ser negativo" }
    
    const response = await DLStartBallonsGame(target, duration, cd, th, toMs)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL StartBallonsGame: ' + error)
    return { success: false, message: `Ha habido un error al iniciar la dinámica de Globos: ${error}` }
  }
}

const RestartBallonsGame = async () => {
  try {
    const response = await DLRestartBallonsGame()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL RestartBallonsGame: ' + error)
    return { success: false, message: `Ha habido un error al intentar resetear la dinámica: ${error}` }
  }
}

const GetBalloonState = async () => {
  try {
    const response = await DLGetBalloonState()
    
    if (response.success) {
      //return { success: true, data: response.data }
      return {
        success: true,
        data: {
          phase: MapStatusToPhase(response.data.status),
          state: response.data
        }
      }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL GetBalloonState: ' + error)
    return { success: false, message: `Ha habido un error al consultar el estado: ${error}` }
  }
}

const GetBalloonStats = async () => {
  try {
    const response = await DLGetBalloonStats()
    
    /* s: {
         matchId, status, startAt, endsAt, targetTapsPerBalloon,
         peakParticipantsTotal,
         currentParticipantsByZone: { [zona]: count },
         resultsByZone: [{ zone, completedBalloons, totalTaps }],
         winnerType, winners
       }
    */

    if (response.success) {
      //return { success: true, data: response.data }
      return {
        success: true,
        data: {
          phase: MapStatusToPhase(response.data.status),
          stats: response.data
        }
      }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log('BL GetBalloonStats: ' + error)
    return { success: false, message: `Ha habido un error al consultar las estadísticas: ${error}` }
  }
}

//---------- BALLONS ADMIN ----------//

//---------- RIDDLE ADMIN ----------//

const GetAllRiddleResults = async () => {
  try {
    const response = await DLGetAllRiddleResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendRiddleResultsToScreen = async () => {
  try {
    const response = await DLSendRiddleResultsToScreen()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendRiddleQuestionToUsers = async (question) => {
  try {
    const response = await DLSendRiddleQuestionToUsers(question)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const ShowItemOnScreen = async (question) => {
  try {
    const response = await DLShowItemOnScreen(question)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- RIDDLE ADMIN ----------//



//---------- LOTTERY FAN ----------//

const ValidateResponse = async (idCard) => {
  try {
    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const response = await DLValidateResponse(idCard, responseZone.data.text)
      
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: response.message }
      }
    } else {
      return { success: false, message: responseZone.message }
    }
  } catch (error) {
    
  }    
}

//---------- LOTTERY FAN ----------//

//---------- BALLONS FAN ----------//

const SendBalloonsTap = async (matchId, zone, toSend) => {
  try {
    const response = await DLSendBalloonsTap(matchId, zone, toSend)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    console.log(error)
  }
}

//---------- BALLONS FAN ----------//

//---------- RIDDLE FAN ----------//

/**
 * Procesa y envía la votación de Adivina Adivinador para el aficionado móvil.
 * Obtiene automáticamente la zona del usuario y valida los parámetros de entrada.
 * 
 * @async
 * @function SubmitRiddleResponse
 * @param {number|string} questionId - Identificador de la pregunta activa.
 * @param {number|string|null} [optionId=null] - Opción elegida por el aficionado.
 * @param {string|null} [userUid=null] - Identificador único de dispositivo/aficionado.
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const SubmitRiddleResponse = async (questionId, optionId = null, userUid = null) => {
  try {
    if (!questionId) {
      return { success: false, message: 'El identificador de la pregunta es requerido.' }
    }

    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const zone = responseZone?.data?.text || responseZone?.data?.canonical || responseZone?.data?.name
      
      if (zone) {
        const response = await DLSubmitRiddleResponse(questionId, zone, optionId, userUid)
        
        if (response.success) {
          return { success: true, data: response.data }
        } else {
          return { success: false, message: response.message }
        }
      }
    }
    return { success: false, message: 'No se pudo verificar la zona del usuario.' }
  } catch (error) {
    return { success: false, message: error?.message || 'Error inesperado al registrar el voto.' }
  }
}

//---------- RIDDLE FAN ----------//


//---------- QuizzWithImageAndOptions ADMIN ----------//

const GetAllQuizzWithImageAndOptionsResults = async () => {
  try {
    const response = await DLGetAllQuizzWithImageAndOptionsResults()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendQuizzWithImageAndOptionsResultsToScreen = async () => {
  try {
    const response = await DLSendQuizzWithImageAndOptionsResultsToScreen()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SendQuizzWithImageAndOptionsQuestionToUsers = async (question) => {
  try {
    const response = await DLSendQuizzWithImageAndOptionsQuestionToUsers(question)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

//---------- QuizzWithImageAndOptions ADMIN ----------//


//---------- QuizzWithImageAndOptions FAN ----------//

const SubmitQuizzWithImageAndOptionsResponse = async (questionId) => {
  try {
    const responseZone = await GetUserZone()
    
    if (responseZone.success) {
      const zone = responseZone?.data?.text
      
      if (zone) {
        const response = await DLSubmitQuizzWithImageAndOptionsResponse(questionId, zone)
        
        if (response.success) {
          return { success: true, data: response.data }
        } else {
          return { success: false, message: response.message }
        }
      }
    } else {

    }
  } catch (error) {
    
  }
}

//---------- QuizzWithImageAndOptions FAN ----------//



const GetAutozoneState  = async () => {
  try {
    const response = await DLGetAutozoneState()
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}

const SetAutozoneState  = async (enabled) => {
  try {
    const response = await DLSetAutozoneState(enabled)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    
  }
}



// ---------- Overlays Websockets ----------//

/**
 * Conecta un Overlay específico al WebSocket.
 * @param {string} overlayType - El subtipo de overlay (ej: "karaoke", "stats").
 * @param {function} onStatusChange - Callback para actualizar estado de conexión (connecting, connected, etc).
 * @param {function} onToast - Callback para mostrar mensajes toast/notificaciones.
 */
const ConnectWebSocketForOverlay = async (overlayType, onStatusChange = () => {}, onToast = () => {}) => {
  // Evitamos doble conexión si ya existe un socket activo
  if (socket || isConnected) return

  const connect = () => {
    // Protección contra bucles infinitos de reconexión
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      onStatusChange('error')
      console.warn('[WebSocket Overlay] 🚫 Límite de reconexiones alcanzado')
      return
    }

    reconnectAttempts++
    
    // AQUÍ ESTÁ LA CLAVE: Construimos la URL con el tipo "overlay:{tipo}"
    // Esto coincide con la lógica que agregamos en el C# (WebSocketConnectionManager)
    const wsUrl = `${process.env.REACT_APP_API_URL_WSS}?tipo=overlay:${overlayType}`
    
    console.log(`[WebSocket Overlay] Conectando a: ${wsUrl}`)
    socket = new WebSocket(wsUrl)
    
    onStatusChange('connecting')

    socket.onopen = () => {
      isConnected = true
      reconnectAttempts = 0
      onStatusChange('connected')
      onToast(`Overlay ${overlayType} Conectado`)
    }

    socket.onclose = () => {
      isConnected = false
      socket = null
      onStatusChange('reconnecting')
      reconnectTimeout = setTimeout(connect, 3000)
    }

    socket.onerror = (e) => {
      console.error('[WebSocket Overlay] ❌ Error de conexión:', e)
      onStatusChange('error')
    }

    // Reutilizamos la instalación del manejador de mensajes existente
    _installOnMessage()
  }

  connect()
}

// ---------- Overlays Websockets ----------//

// Mover a DL
const GetActiveStadiumZones = async () => {
    try {
        // Crearemos este endpoint en C# en el Paso 3
        const response = await fetch(`${process.env.REACT_APP_API_URL}Stadium/ActiveZones`);
        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        }
        return { success: false, data: [] };
    } catch {
        return { success: false, data: [] };
    }
};

export { GetGenderMode, SetGenderMode, IsWebSocketReady, WaitUntilConnected, GetUserZone, ValidateZone, ValidateNumberZone, SaveUserZone, ConnectWebSocket, DisconnectWebSocket, SetSocketMessageHandler, ClearSocketMessageHandler, ConnectWebSocketForScreen, ConnectWebSocketForScreenV2, SubmitResponse, SendQuestionToUsers, GetAllResults, GetResultsByQuestion, ResetAllResults, SendResultsToScreen, GetColors, SetColor, ResetCurrentDynamic, StartLottery, SendNextCard, GetAllLotteryResults, GetAllLotteryResultsByCard, StartBallonsGame, RestartBallonsGame, GetBalloonState, GetBalloonStats, GetAllRiddleResults, SendRiddleResultsToScreen, SendRiddleQuestionToUsers, ShowItemOnScreen, ValidateResponse, SendBalloonsTap, SubmitRiddleResponse, GetAutozoneState, SetAutozoneState, GetAllQuizzWithImageAndOptionsResults, SendQuizzWithImageAndOptionsResultsToScreen, SendQuizzWithImageAndOptionsQuestionToUsers, SubmitQuizzWithImageAndOptionsResponse, ConnectWebSocketForOverlay, GetActiveStadiumZones }; //ValidateUserZone